<template>
	<div class="tc-layer-background" :class="classBackground">
		<div class="tc-layer-background-now" :style="styleNow"></div>
	</div>
</template>
<script>
import { CHART_TICK } from '../../classes/Const';

export default {
	name: 'TCLayerBackground',
	data() {
		return {
		};
	},
	methods: {
	},
	computed: {
		classBackground: function() {
			let classes = [];

			let tick = this.$store.getters['chart/chartTick'];
			if (tick.id === CHART_TICK.SM.id)
				classes.push('chart-tick-sm');
			else if (tick.id === CHART_TICK.MD.id)
				classes.push('chart-tick-md');
			else if (tick.id === CHART_TICK.BG.id)
				classes.push('chart-tick-bg');


			return classes;
		},
		styleNow: function() {
			let position = this.$store.getters['chart/chartOffsetNowLine'];

			return {
				display: (position >= 0) ? 'block' : 'none',
				left: position + 'px',
			};
		},
	},
	mounted: function() {
	},
	beforeDestroy: function() {
	},
};
</script>
<style>
	.tc-layer-background {
		position: absolute;
		width: 100%;
		height: 100%;
		background-color: #fff;
		background-repeat: repeat;
	}

	.tc-layer-background-now {
		position: absolute;
		left: 0;
		height: 100%;
		width: 1px;
		background-color: red;
	}

	.tc-layer-background.chart-tick-sm {
		background-image: url("../../assets/tc-chart-background-sm.png");
	}
	.tc-layer-background.chart-tick-md {
		background-image: url("../../assets/tc-chart-background-md.png");
	}
	.tc-layer-background.chart-tick-bg {
		background-image: url("../../assets/tc-chart-background-bg.png");
	}
</style>
